import type { AnalyticsItemType } from '@/context/analytics-item/interfaces';

export type HomeSectionKey =
  | 'profile'
  | 'idp'
  | 'career_recommendations'
  | 'einstein_cobrand'
  | 'ai_courses'
  | 'ai_videos'
  | 'career_videos'
  | 'company_learning_paths'
  | 'learning_paths'
  | 'course_types'
  | 'knowledge_areas';

export enum HomeEvent {
  VisitEnded = 'Home Visit Ended',
  ItemClicked = 'Home Item Clicked',
}

export interface HomeEventProperties {
  [HomeEvent.VisitEnded]: {
    sections_viewed: HomeSectionKey[];
    deepest_position: number;
    sections_available: number;
    duration_seconds: number;
  };
  [HomeEvent.ItemClicked]: {
    section: HomeSectionKey;
    section_position: number;
    item_type: AnalyticsItemType;
    item_id: number | string;
    position?: number;
  };
}
